.form-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#security-telemetry-events {
  display: flex;
}
.event-column {
  width: calc(var(--spacer) * 30);
}

#bypass-validation-checkbox {
  margin-left: 250px; // distance set based on form field label-mw-250
}

#ssl-info-box {
  padding-left: 0;
  --info-box-width: 100%;
  --info-box-max-width: calc(var(--spacer) * 83);
}

.warning-text {
  font-weight: 400;
  font-size: 14px;
}

#serverUrl {
  display: flex;
  flex-direction: row;
}

#url-spinner {
  margin-left: calc(var(--spacer));
  margin-top:calc(var(--spacer) / 2);
}
